import React, { useMemo } from 'react';
import { fetchDirectory, fetchDirectoryItem } from '../../data/fetch';
import { useStoredDataChanged } from './useStoredDataChanged';
import Loader from './Loader';

const LoadDirectoryItem = ({ eventId, items = [], children }) => {
    useStoredDataChanged();

    // NOTE: catch included so errors can be ignored (app will just route out if no content is found)
    const fetchPromises = useMemo(
        () => items.filter((i) => i).map((itemId) => fetchDirectoryItem(eventId, itemId).then(() => fetchDirectory(eventId, itemId).catch((err) => console.warn(err)))),
        [...items]
    );

    return <Loader promises={fetchPromises}>{children}</Loader>;
};

export default LoadDirectoryItem;
